<template>
  <div>
    <v-dialog
      max-width="500"
      persistent
      scrollable
      v-if="isOpenDialer"
      :value="isOpenDialer"
      @click:outside="toggleDialog"
    >
      <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
        <v-card>
          <v-progress-linear v-if="isLoading" indeterminate color="primary" rounded height="6"></v-progress-linear>

          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Marcar
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text class="mb-5" style="max-height: 350px">
              <v-form ref="dialerForm">
                <v-row>
                  <!-- Colas -->
                  <v-col cols="12" class="py-0">
                    <ValidationProvider name="Cola" rules="required" v-slot="{ errors }">
                      <v-select
                        v-model="payload.queue"
                        :items="queueList"
                        :error-messages="errors"
                        :loading="isLoadingQueues"
                        item-text="name"
                        item-value="number"
                        prepend-inner-icon="mdi-database"
                        label="Cola"
                        filled
                        rounded
                      ></v-select>
                    </ValidationProvider>
                  </v-col>
                  <!-- Numero -->
                  <v-col cols="12" class="py-0">
                    <ValidationProvider name="número" rules="required" v-slot="{ errors }">
                      <v-text-field
                        v-model="payload.call_number"
                        :error-messages="errors"
                        label="Número a marcar"
                        prepend-inner-icon="mdi-phone"
                        filled
                        rounded
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <!--                 
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="payload.type"
                    :error-messages="errors"
                    label="Tipo"
                    prepend-inner-icon="mdi-bookshelf"
                    filled
                    rounded
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="payload.variable_1"
                    :error-messages="errors"
                    label="Variable 1"
                    prepend-inner-icon="mdi-compare-vertical"
                    filled
                    rounded
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="payload.variable_2"
                    :error-messages="errors"
                    label="Variable 2"
                    prepend-inner-icon="mdi-compare-vertical"
                    filled
                    rounded
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="payload.variable_3"
                    :error-messages="errors"
                    label="Variable 3"
                    prepend-inner-icon="mdi-compare-vertical"
                    filled
                    rounded
                  ></v-text-field>
                </v-col> -->
                </v-row>
              </v-form>
            </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2 white">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="toggleDialog">
                Cancelar
              </v-btn>
            </v-hover>
            <v-btn-toggle v-if="hasRTC">
              <v-btn small :loading="isLoading" :disabled="isLoading" color="success" @click="handleSubmit(submitForm)">
                <v-icon color="white">mdi-phone</v-icon>
              </v-btn>

              <v-btn
                small
                :loading="isLoading"
                :disabled="isLoading"
                color="success"
                @click="handleSubmit(() => submitForm(true))"
              >
                <v-icon color="white">mdi-video</v-icon>
              </v-btn>
            </v-btn-toggle>
            <v-btn
              v-else
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click="handleSubmit(submitForm)"
            >
              Llamar
            </v-btn>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>

    <call-banner
      :showCallBanner="showCallBanner"
      :callStatusText="callStatusText"
      :hasIncomingCall="hasIncomingCall"
      :displayName="displayName"
      :phoneNumber="numberToCall"
      :hasInProgressCall="showCallCounter"
      :counterStatus="counterStatus"
      :isMuted="callButtons.mute"
      :isActiveHold="oSipSessionCall && oSipSessionCall.bHeld"
      :isVideoCall="isVideoCall"
      @call:toggleMute="sipToggleMute"
      @call:toggleHold="sipToggleHoldResume"
      @call:transfer="sipTransfer"
      @call:answer="sipCall"
      @call:hangup="sipHangUp"
      @call:dtmf="sipSendDTMF"
    ></call-banner>
  </div>
</template>

<script>
import vuescroll from "vuescroll";
import axios from "axios";
import { PbxHttpClient } from "@/services/httpclient";
import CallBanner from "./CallBanner.vue";
import { getRealmUrl } from "../../Utils/getRealmUrl";
import {
  startRingTone,
  stopRingTone,
  startRingbackTone,
  stopRingbackTone,
  checkNotificationPermission,
} from "../../Utils/SIPHelpers";

export default {
  components: { vuescroll, CallBanner },

  data() {
    return {
      isLoading: false,
      isLoadingQueues: true,
      itLoadSipAPI: false,
      payload: {
        call_number: "",
        queue: null,
        type: "0",
        variable_1: "",
        variable_2: "",
        variable_3: "",
      },
      queueList: [],
      dataFromCall: {},
      // SIPml5
      oSipStack: null,
      oSipSessionCall: null,
      oSipSessionTransferCall: null,
      oSipSessionRegister: null,
      oNotifICall: null,
      oConfigCall: {},
      callStatusText: "Llamando",
      numberToCall: "",
      showCallBanner: false,
      showCallCounter: false,
      counterStatus: "play",
      DTMF: "",
      hasIncomingCall: false,
      callButtons: {
        mute: false,
        hold: false,
      },
      videoLocal: null,
      videoRemote: null,
      isVideoCall: false,
      displayName: "",
    };
  },

  computed: {
    ProfileInfo() {
      return this.$store.getters["passport/CURRENT_USER"];
    },
    isOpenDialer() {
      return this.$store.getters["dialer/GET_IS_OPEN"];
    },
    hasRTC() {
      return !!this.ProfileInfo.web_rtc;
    },
    AutoAnswerCalls() {
      return !!this.ProfileInfo.web_rtc?.auto_answer;
    },
    isConnectedToSIP() {
      return this.$store.getters["dialer/GET_IS_CONNECTED"];
    },
    startCall() {
      return this.$store.getters["dialer/GET_START_DIRECT_CALL"];
    },
    IsFromCampaignRegister() {
      return this.$store.getters["dialer/GET_IS_FOR_CAMPAIGNS_REGISTER"];
    },
  },

  created() {
    this.getQueues();

    this.payload.call_number = this.$store.getters["dialer/GET_NUMBER_TO_CALLL"] || "";
    this.payload.queue = this.$store.getters["dialer/GET_QUEUE_TO_CALL"] || null;
  },

  mounted() {
    const script = document.createElement("script");
    script.src = "SIPml-api.js";
    script.onload = async () => {
      this.itLoadSipAPI = true;
      const shouldConnect = this.isConnectedToSIP || this.AutoAnswerCalls;
      if (shouldConnect && this.ProfileInfo.web_rtc) await this.loadSipml(true);
      // else this.$store.dispatch("dialer/TOGGLE_IS_CONNECTED");
    };
    document.body.appendChild(script);
    // if (JSON.parse(localStorage.getItem("sip")))
    //   setTimeout(() => {
    //     this.loadSipml();
    //   }, 4500);
  },

  watch: {
    isConnectedToSIP(val) {
      if (this.itLoadSipAPI) this.loadSipml(val);
    },
    ProfileInfo() {
      if (this.isConnectedToSIP && this.ProfileInfo.web_rtc) this.loadSipml(true);
    },
    startCall(val) {
      if (!val) return;
      const call_number = this.$store.getters["dialer/GET_NUMBER_TO_CALLL"];

      this.sipCall({ call_number });
    },
  },

  beforeDestroy() {
    this.loadSipml(false);
  },

  methods: {
    async getQueues() {
      try {
        const { data } = await PbxHttpClient.get(`/clients/queues`);
        this.queueList = data.data;

        if (this.queueList.length > 0) this.payload.queue = data.data[0].number;

        // const salida = data.data.find((el) => el.name === "salida");
        this.payload = { ...this.payload, queue: data.data[0].number };
      } catch (err) {
        // console.log(err);
        this.$snotify.error("Hubo un error consultando las colas.", "¡Error!");
      }
      this.isLoadingQueues = false;
    },
    async submitForm(isVideo = false) {
      if (this.ProfileInfo.web_rtc && this.isConnectedToSIP) {
        this.isVideoCall = isVideo;
        this.sipCall(this.payload, isVideo ? "call-audiovideo" : undefined);
        this.toggleDialog();
        return;
      }

      this.isLoading = true;
      try {
        await PbxHttpClient.post(`/typing/call_now`, this.payload);
        this.$snotify.success("Llamada realizada con éxito.", "¡Hecho!");
        this.closeDialogAndSendTypification();
      } catch (error) {
        this.$snotify.error("Hubo un error realizando la llamada.", "¡Error!");
      }
      this.isLoading = false;
    },
    toggleDialog() {
      this.$refs.dialerForm.reset();
      this.$store.dispatch("dialer/TOGGLE_OPEN_DIALOG");
    },
    closeDialogAndSendTypification() {
      this.$emit("finished:call", { ...this.payload });
      this.toggleDialog();
    },

    async createTypificationRegistry() {
      console.log("creando....");
      try {
        await axios.post(
          `${process.env.VUE_APP_URL_BASE}:8096/api/temporary_table/create/front`,
          {
            extension: this.ProfileInfo.extension,
            ...this.dataFromCall,
            type: "S",
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        // console.log("data from post t", data);
      } catch (error) {
        // console.log(error);
        this.$snotify.error("Hubo un error buscando la tipificacion.", "¡Error!");
      }
    },

    openNewPage() {
      if (this.ProfileInfo.client.url_new_page) window.open(this.ProfileInfo.client.url_new_page, "_blank");
    },

    async loadSipml(connect) {
      if (!connect) {
        if (!this.oSipStack) return;
        try {
          await this.oSipStack.stop();
          localStorage.removeItem("sip");
        } catch (err) {
          localStorage.setItem("sip", true);
        }
        return;
      }

      const user = this.ProfileInfo;

      return await new Promise((res) => {
        // eslint-disable-next-line no-undef
        this.oSipStack = new SIPml.Stack({
          realm: getRealmUrl(user.web_rtc.public_identity) ?? "combipollo.pbxberry.com",
          impi: user.extension,
          impu: user.web_rtc.public_identity,
          password: user.web_rtc.Password,
          display_name: user.extension,
          websocket_proxy_url: this.ProfileInfo.client.web_socket_server_url || "wss://combipollo.pbxberry.com:8089/ws",
          enable_rtcweb_breaker: false,
          events_listener: {
            events: "*",
            listener: this.onSipEventStack,
          },
          enable_early_ims: true, // Must be true unless you're using a real IMS network
          enable_media_stream_cache: false,
          bandwidth: null, // could be redefined a session-level
          video_size: null, // could be redefined a session-level
          sip_headers: [
            {
              name: "User-Agent",
              value: "IM-client/OMA1.0 sipML5-v1.2016.03.04",
            },
            { name: "Organization", value: "Doubango Telecom" },
          ],
        });

        const audio_remote = document.getElementById("audio_remote");
        this.videoLocal = document.getElementById("video_local");
        this.videoRemote = document.getElementById("video_remote");
        this.oConfigCall = {
          audio_remote,
          video_local: document.getElementById("video_local"),
          video_remote: document.getElementById("video_remote"),
          screencast_window_id: 0x00000000, // entire desktop
          bandwidth: { audio: undefined, video: undefined },
          video_size: {
            minWidth: 300,
            minHeight: 300,
            maxWidth: undefined,
            maxHeight: undefined,
          },
          ice_servers: [],
          events_listener: { events: "*", listener: this.onSipEventSession },
          sip_caps: [{ name: "+g.oma.sip-im" }, { name: "language", value: '"en,fr"' }],
        };

        const itStart = this.oSipStack.start();
        setTimeout(() => {
          if (itStart !== 0) {
            res(false);
            this.$snotify.error("Failed to start the SIP stack", "Error");
          }
          localStorage.setItem("sip", "true");
          this.isLoadSipml = true;
          res(true);
        }, 3000);
      });
      // if (this.oSipStack.start() != 0) {
      //   this.$snotify.error("Failed to start the SIP stack", "Error");
      // }
      // else console.log("run successfull");
    },
    onSipEventStack(e /*SIPml.Stack.Event*/) {
      switch (e.type) {
        case "started": {
          try {
            this.oSipSessionRegister = this.oSipStack.newSession("register", {
              expires: 200,
              events_listener: {
                events: "*",
                listener: this.onSipEventSession,
              },
              sip_caps: [
                { name: "+g.oma.sip-im", value: null },
                { name: "+audio", value: null },
                { name: "language", value: '"en,fr"' },
              ],
            });
            this.oSipSessionRegister.register();
          } catch (e) {
            console.log("catch", e);
          }
          break;
        }
        case "stopping":
        case "stopped":
        case "failed_to_start":
        case "failed_to_stop": {
          stopRingbackTone();
          stopRingTone();
          break;
        }

        case "i_new_call":
          if (this.oSipSessionCall) {
            e.newSession.hangup(); // comment this line for multi-line support
          } else {
            this.oSipSessionCall = e.newSession;
            // start listening for events
            this.oSipSessionCall.setConfiguration(this.oConfigCall);
            // console.log("### INCOMING NEW CALL ");
            this.displayName = e.o_event.o_message.o_hdr_From.s_display_name;
            const sRemoteNumber = this.oSipSessionCall.getRemoteFriendlyName() || "unknown";
            this.showCallBanner = true;
            // Auto answer when the setting is true
            if (this.AutoAnswerCalls) {
              this.sipCall({ call_number: sRemoteNumber });
              return;
            }

            startRingTone();

            this.callStatusText = `Llamada entrante: ${sRemoteNumber}`;

            this.hasIncomingCall = true;
            this.showNotifICall(sRemoteNumber);
          }
          break;

        case "m_permission_refused":
          // console.log("Permission refused");
          this.$snotify.error("Ha denegado el acceso a su microfono.", "Error");
          break;

        case "starting":
        default:
          break;
      }
    },
    sipCall(payload, s_type = "call-audio") {
      //
      if (this.oSipStack && !this.oSipSessionCall) {
        this.dataFromCall = { ...payload };
        const number = payload.call_number;
        // create call session
        this.oSipSessionCall = this.oSipStack.newSession(s_type, this.oConfigCall);
        // make call
        if (this.oSipSessionCall.call(number) != 0) {
          console.log("Failed to make call");
          return;
        }
        this.$store.dispatch("dialer/CHANGE_CALL_STATUS", true);
        if (!this.startCall && !this.IsFromCampaignRegister) this.createTypificationRegistry();
        this.numberToCall = number;
      } else if (this.oSipSessionCall) {
        // console.log("Connecting...");
        this.oSipSessionCall.accept(this.oConfigCall);
        this.hasIncomingCall = false;
      }
      this.openNewPage();
      if (!this.startCall && !this.IsFromCampaignRegister) {
        this.$emit("finished:call", { ...payload });
      }
    },
    onSipEventSession(e /* SIPml.Session.Event */) {
      console.log("==session event = " + e.type);
      switch (e.type) {
        case "connecting":
        case "connected":
          // eslint-disable-next-line no-case-declarations
          const bConnected = e.type == "connected";
          // eslint-disable-next-line no-empty
          if (e.session == this.oSipSessionRegister) {
          } else if (e.session == this.oSipSessionCall) {
            this.showCallBanner = true;
            if (bConnected) {
              this.callStatusText = "Llamada en curso";
              this.showCallCounter = true;
              this.counterStatus = "play";
              stopRingbackTone();
              stopRingTone();

              // if (oNotifICall) {
              //   oNotifICall.cancel();
              //   oNotifICall = null;
              // }
            }
            // if (SIPml.isWebRtc4AllSupported()) {
            this.uiVideoDisplayEvent(false, true);
            this.uiVideoDisplayEvent(true, true);
            // }
          }
          break;
        case "terminating":
        case "terminated":
          if (e.session == this.oSipSessionRegister) {
            this.oSipSessionCall = null;
            this.oSipSessionRegister = null;
            this.isVideoCall = false;
            // console.log(
            //   "event terminated description: equal session",
            //   e.description
            // );
          } else if (e.session == this.oSipSessionCall) {
            this.isVideoCall = false;
            // console.log("event terminated description:", e.description);
            if (e.description === "Busy Here") this.$snotify.warning("Llamada rechazada");
          }
          if (e.type === "terminated") this.oSipSessionCall = null;
          this.showCallBanner = false;
          this.showCallCounter = false;
          this.callStatusText = "Llamando";
          this.counterStatus = "pause";

          stopRingbackTone();
          stopRingTone();
          break;
        case "m_stream_audio_local_added":
        case "m_stream_audio_local_removed":
        case "m_stream_audio_remote_added":
        case "m_stream_audio_remote_removed": {
          break;
        }
        case "m_stream_video_local_added": {
          if (e.session == this.oSipSessionCall) {
            this.uiVideoDisplayEvent(true, true);
          }
          break;
        }
        case "m_stream_video_local_removed": {
          if (e.session == this.oSipSessionCall) {
            this.uiVideoDisplayEvent(true, false);
          }
          break;
        }
        case "m_stream_video_remote_added": {
          if (e.session == this.oSipSessionCall) {
            this.isVideoCall = true;
            this.uiVideoDisplayEvent(false, true);
          }
          break;
        }
        case "m_stream_video_remote_removed": {
          if (e.session == this.oSipSessionCall) {
            this.uiVideoDisplayEvent(false, false);
          }
          break;
        }

        case "m_local_hold_ok": {
          if (e.session == this.oSipSessionCall) {
            if (this.oSipSessionCall.bTransfering) this.oSipSessionCall.bTransfering = false;
            this.oSipSessionCall.bHeld = true;
            this.callStatusText = "Llamada en pausa";
          }
          break;
        }
        case "m_local_hold_nok": {
          if (e.session == this.oSipSessionCall) {
            this.oSipSessionCall.bTransfering = false;
          }
          break;
        }
        case "m_local_resume_ok":
          if (e.session == this.oSipSessionCall) {
            this.oSipSessionCall.bTransfering = false;
            this.oSipSessionCall.bHeld = false;
            this.callStatusText = "Llamada en curso";
          }
          break;
        case "m_local_resume_nok":
          if (e.session == this.oSipSessionCall) this.oSipSessionCall.bTransfering = false;

          break;
        case "i_ao_request":
          if (e.session == this.oSipSessionCall) {
            var iSipResponseCode = e.getSipResponseCode();
            if (iSipResponseCode == 180 || iSipResponseCode == 183) {
              startRingbackTone();
            }
          }
          break;
        case "i_ect_new_call":
          this.oSipSessionTransferCall = e.session;
          break;
        case "m_remote_hold":
          if (e.session == this.oSipSessionCall) this.callStatusText = "Placed on hold by remote party";

          break;

        case "m_remote_resume":
          if (e.session == this.oSipSessionCall) this.callStatusText = "Taken off hold by remote party";

          break;

        case "o_ect_trying":
          if (e.session == this.oSipSessionCall) this.callStatusText = "Transfiriendo Llamada";

          break;

        case "o_ect_accepted":
          if (e.session == this.oSipSessionCall) this.callStatusText = "Transferencia aceptada";
          this.$snotify.success("Transferencia aceptada");
          break;

        case "o_ect_completed":
        case "i_ect_completed":
          if (e.session == this.oSipSessionCall) {
            this.callStatusText = "Transferencia completada";
            // eslint-disable-next-line no-undef
            if (oSipSessionTransferCall) this.oSipSessionCall = oSipSessionTransferCall;
            this.$snotify.success("Transferencia de llamada completada", "¡Hecho!");

            this.oSipSessionTransferCall = null;
          }
          break;

        case "o_ect_failed":
        case "i_ect_failed":
          if (e.session == this.oSipSessionCall)
            // console.log("Call transfer failed");

            break;
          break;

        case "o_ect_notify":
        case "i_ect_notify":
          if (e.session == this.oSipSessionCall) {
            this.callStatusText = "Tranferencia de llamada: " + e.getSipResponseCode() + " " + e.description;
            if (e.getSipResponseCode() >= 300) {
              if (this.oSipSessionCall.bHeld) {
                this.oSipSessionCall.resume();
              }
            }
          }
          break;
        case "i_ect_requested":
          if (e.session == this.oSipSessionCall) {
            const s_message = "Do you accept call transfer to [" + e.getTransferDestinationFriendlyName() + "]?"; //FIXME
            if (confirm(s_message)) {
              this.oSipSessionCall.acceptTransfer();
              break;
            }
            this.oSipSessionCall.rejectTransfer();
          }
          break;
      }
    },
    sipHangUp() {
      if (this.oSipSessionCall) {
        this.callStatusText = "Finalizando llamada";
        this.oSipSessionCall.hangup({
          events_listener: { events: "*", listener: this.onSipEventSession },
        });

        this.$store.dispatch("dialer/CHANGE_CALL_STATUS", false);
        if (this.startCall) this.$store.dispatch("dialer/STOP_DIRECT_CALL");
      }
    },
    sipToggleMute() {
      if (this.oSipSessionCall) {
        let i_ret;
        const bMute = !this.oSipSessionCall.bMute;

        i_ret = this.oSipSessionCall.mute("audio" /*could be 'video'*/, bMute);
        if (i_ret != 0) {
          // eslint-disable-next-line no-undef
          txtCallStatus.innerHTML = "<i>Mute / Unmute failed</i>";
          return;
        }
        this.callButtons.mute = bMute;
        this.oSipSessionCall.bMute = bMute;
      }
    },
    sipToggleHoldResume() {
      if (this.oSipSessionCall) {
        // eslint-disable-next-line no-unused-vars
        const i_ret = this.oSipSessionCall.bHeld ? this.oSipSessionCall.resume() : this.oSipSessionCall.hold();

        this.counterStatus = this.oSipSessionCall.bHeld ? "play" : "pause";
      }
    },
    sipTransfer() {
      if (this.oSipSessionCall) {
        var s_destination = prompt("Enter destination number", "");
        if (s_destination.length) {
          if (this.oSipSessionCall.transfer(s_destination) != 0) return;

          this.callStatusText = "Transfiriendo Llamada";
        }
      }
    },

    async showNotifICall(incomingNumber) {
      if (await checkNotificationPermission()) {
        this.oNotifICall?.cancel();

        this.oNotifICall = new Notification("Llamada entrante", {
          body: `Llamada entrante de ${incomingNumber}`,
        });
        this.oNotifICall.onclose = function() {
          this.oNotifICall = null;
        };
        this.oNotifICall.show();
      }
    },
    sipSendDTMF(value) {
      const c = value.split("").pop();
      console.log("c", c);
      const dtmfTone = document.getElementById("dtmfTone");
      if (this.oSipSessionCall && c)
        if (this.oSipSessionCall.dtmf(c) == 0) {
          try {
            dtmfTone.play();
          } catch (e) {
            console.log("error sending DTMF", e);
          }
        } else {
          console.log("not working");
        }
    },
    uiVideoDisplayEvent(b_local, b_added) {
      const videoLocal = document.getElementById("video_local");
      const videoRemote = document.getElementById("video_remote");
      const o_elt_video = b_local ? videoLocal : videoRemote;

      if (b_added) {
        o_elt_video.style.opacity = 1;
      } else {
        o_elt_video.style.opacity = 0;
      }
    },
  },
};
</script>

<style></style>
